import React, { Component } from 'react'

// Create new context
export const LocationContext = React.createContext()

// Then create a Provider Component
export class LocationProvider extends Component {

    state = {
        location: []
    }

    changeLocation = (e) => {
        this.state.location.push(e);
        // this.setState({
        //     location: []
        // })
    }

    render() {
        return (
            <LocationContext.Provider value={{
                state: this.state,
                changeLocation: this.changeLocation
            }}>
                {this.props.children}
            </LocationContext.Provider>
        )
    }

}